import { Howl } from "howler";
import audios from "./audio/audio";

class SoundController {
  constructor() {
    this._internal = null;
    this._muted = false;
    this._soundId = -1;
  }

  _createUtteranceWithArrayBuffer(resAudioContent) {
    const BASE64_AUDIO_MP3_PREFIX = "data:audio/x-mp3;base64,";
    if (!Array.isArray(resAudioContent)) {
      resAudioContent = [resAudioContent];
    }
    const base64Strings = resAudioContent.map(
      (AudioContent) =>
        BASE64_AUDIO_MP3_PREFIX +
        btoa(
          new Uint8Array(AudioContent).reduce(
            (data, byte) => data + String.fromCharCode(byte),
            ""
          )
        )
    );
    this._createUtterance(base64Strings, false);
  }

  _createUtterance(src, autoplay) {
    if (this._internal && this._internal.playing(this._soundId)) {
      this.stop();
    }
    this._internal = new Howl({
      src,
      autoplay,
      loop: false,
      volume: 1,
      mute: this._muted,
    });
  }

  play(resAudioContent) {
    this._createUtteranceWithArrayBuffer(resAudioContent, false);
    this._soundId = this._internal.play();
  }

  toggleMute() {
    this._muted = !this._muted;
    if (this._internal) {
      this._internal.mute(this._muted);
    }
  }

  stop() {
    if (this._internal) {
      this._internal.stop();
    }
  }

  playPreRecordedMessage(messageName) {
    this.stop();
    this._createUtterance([audios[messageName]["base64"]], false);
    this._soundId = this._internal.play();
  }
}

export default SoundController;
